import { FC, useEffect, useState } from 'react'
import { useUser, useAuthUI } from '@corratech/pylot-auth-manager'
import { useUI } from '@corratech/pylot-ui/context'
import { useRouter } from 'next/router'

type PropTypes = {
    authRequired: boolean
}

export const STORE_CODE = 'ooka_'

const AuthWrapper: FC<PropTypes> = ({ authRequired, children }) => {
    const { isSignedIn, loading } = useUser()
    const { LoadingIndicator } = useUI()
    const router = useRouter()
    const { openAuthModal } = useAuthUI()

    // State to keep track of whether auth modal was opened
    const [authModalOpened, setAuthModalOpened] = useState(false)

    useEffect(() => {
        if (!loading && !isSignedIn && authRequired && !authModalOpened) {
            setAuthModalOpened(true)
            // Save current path to redirect after successful login
            sessionStorage.setItem('redirectPath', router.asPath)

            router.push('/').then(() => {
                openAuthModal()
            })
        }
    }, [loading, isSignedIn, authModalOpened])

    useEffect(() => {
        if (isSignedIn) {
            const redirectPath = sessionStorage.getItem('redirectPath')
            if (redirectPath) {
                sessionStorage.removeItem('redirectPath')
                router.push(redirectPath)
            }
        }
    }, [isSignedIn, authModalOpened])

    //consider loading state for only protected routes
    if (loading && authRequired) {
        return (
            <div className="mx-auto max-w-xs">
                <LoadingIndicator />
            </div>
        )
    }

    //Authentication error handler
    if (!isSignedIn && authRequired) return null

    return <>{children}</>
}

export default AuthWrapper
